export default __webpack_public_path__ + "static/media/LF-1.5bd20d4f.png";